import { useState, useEffect, useRef } from 'react';
import { authenticatedFetch } from '../../../utils/api';

const useFulfillmentData = ({ activeComponent, securityData, setSecurityData, securityDataLoaded, setSecurityDataLoaded }) => {
    const [fulfillmentLoading, setFulfillmentLoading] = useState(false);
    const fulfillmentFetchedRef = useRef(false);

    useEffect(() => {
        if (activeComponent !== 'fulfillment') return;
        if (securityDataLoaded || fulfillmentFetchedRef.current) return;
        fulfillmentFetchedRef.current = true;

        const fetchFulfillmentData = async () => {
            setFulfillmentLoading(true);
            try {
                const [summaryRes, weeksRes] = await Promise.all([
                    authenticatedFetch('/ManagerReport/GetSecurityFulfillmentSummary'),
                    authenticatedFetch('/ManagerReport/GetFinancialWeeks'),
                ]);
                const summary = summaryRes.ok ? await summaryRes.json() : [];
                const weeksData = weeksRes.ok ? await weeksRes.json() : null;
                setSecurityData(prev => ({
                    ...prev,
                    securitySummary: Array.isArray(summary) ? summary : [],
                    financialWeeks: weeksData?.item1 || prev.financialWeeks,
                }));
                setSecurityDataLoaded(true);
            } catch (err) {
                console.error('Fulfilment data fetch error:', err);
            } finally {
                setFulfillmentLoading(false);
            }
        };

        fetchFulfillmentData();
    }, [activeComponent, securityDataLoaded]);

    return { fulfillmentLoading };
};

export default useFulfillmentData;
